export default __webpack_public_path__ + "media/images/bm-certification-logo.png";